import { render, staticRenderFns } from "./formsPieChart.vue?vue&type=template&id=bfe3c5f4&scoped=true&"
import script from "./formsPieChart.vue?vue&type=script&lang=js&"
export * from "./formsPieChart.vue?vue&type=script&lang=js&"
import style0 from "./formsPieChart.vue?vue&type=style&index=0&id=bfe3c5f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe3c5f4",
  null
  
)

export default component.exports